"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInternalRoutePageTreeForRoute = exports.buildInternalRoute = void 0;
var getMasterPagesUriPrefix = function (country) {
    return "".concat(country.isRegionMaster ? "___MASTER_".concat(country.region.regionCode, "___") : '');
};
var buildInternalRoute = function (tree, localeIdentifier) {
    var routes = [];
    // 1. Handle all cases where just a slash is returned.
    if (!tree || !tree._id || !tree._type) {
        return '/';
    }
    if (tree._type === 'rootPage') {
        return '/';
    }
    if (!tree.slug ||
        !tree.slug.current ||
        !tree.localeIdentifier ||
        !tree.localeIdentifier.localeId ||
        !tree.localeIdentifier.country ||
        !tree.localeIdentifier.country.region ||
        !tree.localeIdentifier.country.region.regionCode) {
        return '/';
    }
    // 2. Set the localIdentifier to use.
    var actualLocalIdentifier = localeIdentifier || tree.localeIdentifier;
    // 3. Add the slug of the page.
    routes.push(tree.slug.current);
    // 4. Add all other parent page slugs.
    var addRouteSegments = function (currentPage, routeArray) {
        if (!currentPage || !currentPage._id || !currentPage._type) {
            throw new Error('Error while processing page tree.');
        }
        // Reached the end, stop here.
        if (currentPage._type === 'rootPage') {
            return;
        }
        if (!currentPage.slug || !currentPage.slug.current) {
            throw new Error('Error while processing page tree.');
        }
        routeArray.push(currentPage.slug.current);
        addRouteSegments(currentPage.parentPage, routeArray);
    };
    try {
        addRouteSegments(tree.parentPage, routes);
    }
    catch (error) {
        return '/';
    }
    // 5. Add the locale id.
    routes.push(actualLocalIdentifier.localeId);
    // 6. Add additional prefix for master pages.
    var masterPagesUriPrefix = getMasterPagesUriPrefix(actualLocalIdentifier.country);
    if (masterPagesUriPrefix) {
        routes.push(masterPagesUriPrefix);
    }
    // 7. Build the route with a leading slash and remove all double slashes and tailing slashes.
    return "/".concat(routes.reverse().join('/')).replace('//', '/').replace(/\/$/, '');
};
exports.buildInternalRoute = buildInternalRoute;
/**
 * Helper function to get an internalRoutePageTree from a route string.
 *
 * This should only be uses in tests or storybook to reduce the required code when working
 * with routes.
 *
 * @param route string
 */
var getInternalRoutePageTreeForRoute = function (route) {
    if (route === void 0) { route = '/'; }
    var rootPage = {
        _id: 'rootPage',
        _type: 'rootPage',
        title: 'Bemer',
    };
    if (!route || route === '/' || route === '#') {
        return rootPage;
    }
    // Get the localeId
    var sanitizedRoute = route[0] === '/' ? route : "/".concat(route);
    var separateLocaleFromRouteMatch = sanitizedRoute.match(/(\/)([a-z]{2}_[A-Z]{2})(\/)(.*)/);
    if (!separateLocaleFromRouteMatch ||
        !separateLocaleFromRouteMatch[2] ||
        !separateLocaleFromRouteMatch[4]) {
        return rootPage;
    }
    var localeId = separateLocaleFromRouteMatch[2];
    var splitRoutes = separateLocaleFromRouteMatch[4].split('/');
    var routes = splitRoutes.reverse();
    var buildPage = function (index) {
        if (!routes || !routes[index]) {
            return rootPage;
        }
        var nextIndex = routes[index + 1] === localeId ? index + 2 : index + 1;
        return {
            _id: "page-".concat(index),
            internalName: "P000".concat(index),
            _type: 'page',
            title: "".concat(routes[index][0].toUpperCase()).concat(routes[index].slice(1)),
            slug: {
                current: routes[index],
            },
            localeIdentifier: {
                _id: "localeIdentifier-".concat(localeId),
                localeId: localeId,
                country: {
                    isRegionMaster: false,
                    region: {
                        regionCode: 'EUROPE',
                    },
                },
            },
            parentPage: buildPage(nextIndex),
        };
    };
    return buildPage(0);
};
exports.getInternalRoutePageTreeForRoute = getInternalRoutePageTreeForRoute;
